import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as CookieConsent from 'vanilla-cookieconsent';
import { isGoogleAnalyticsConfigured, trackGoogleAnalyticsPageView } from '../lib/googleAnalytics';

const ADMIN_PATH = '/admin-secret-wownautic-2024';

/**
 * Envoie une page vue GA4 à chaque navigation (SPA), si analytics accepté.
 */
const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (!isGoogleAnalyticsConfigured()) return;
    if (location.pathname.startsWith(ADMIN_PATH)) return;
    if (!CookieConsent.acceptedCategory('analytics')) return;

    trackGoogleAnalyticsPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default GoogleAnalytics;
